module.exports = __webpack_public_path__ + "static/media/klasa_1.4c59d900.svg";